import { api, ApiError } from './api';
import { BASE_URL } from '../config/environment';

export interface MerchResponse {
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  merchCategory: {
    id: number;
    name: string;
    createdAt: string;
    updatedAt: string;
  };
  agency: {
    id: number;
    name: string;
    createdAt: string;
    updatedAt: string;
  };
}

export interface MerchListResponse {
  merch: MerchResponse[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}

export interface GetMerchParams {
  limit?: number;
  offset?: number;
  agencyId?: number;
  merchCategoryId?: number;
}

export const merch = {
  getList: async (params: GetMerchParams): Promise<MerchListResponse> => {
    try {
      const response = await api.get<MerchListResponse>('/merch', { params });
      return {
        ...response,
        merch: response.merch.map((item) => ({
          ...item,
          imageUrl: item.imageUrl ? `${BASE_URL}/${item.imageUrl}` : '',
        })),
      };
    } catch (error) {
      const apiError = error as ApiError;
      throw apiError;
    }
  },

  create: async (data: FormData): Promise<MerchResponse> => {
    try {
      const response = await api.post('/merch', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      const apiError = error as ApiError;
      throw apiError;
    }
  },

  update: async (id: number, data: FormData): Promise<MerchResponse> => {
    try {
      const response = await api.patch(`/merch/${id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      const apiError = error as ApiError;
      throw apiError;
    }
  },

  delete: async (id: number): Promise<void> => {
    try {
      await api.delete(`/merch/${id}`);
    } catch (error) {
      const apiError = error as ApiError;
      throw apiError;
    }
  },
};
